import { broker } from '@axo/shared/data-access/types';

export interface ICommunicationTemplateKeyParams {
  marketCountry: string | undefined;
}

export const communicationTemplateKeys = {
  root: (params: ICommunicationTemplateKeyParams) =>
    ['communicationTemplate', params.marketCountry] as const,

  commentTemplates: (params: ICommunicationTemplateKeyParams) =>
    [...communicationTemplateKeys.root(params), 'commentTemplates'] as const,

  emailTemplates: (
    params: ICommunicationTemplateKeyParams & { broker: broker.Broker },
  ) =>
    [
      ...communicationTemplateKeys.root(params),
      'emailTemplates',
      params.broker,
    ] as const,

  smsTemplates: (
    params: ICommunicationTemplateKeyParams & { broker: broker.Broker },
  ) =>
    [
      ...communicationTemplateKeys.root(params),
      'smsTemplates',
      params.broker,
    ] as const,

  callTags: (params: ICommunicationTemplateKeyParams) =>
    [...communicationTemplateKeys.root(params), 'callTags'] as const,
};

export function parseCommunicationTemplateKey<
  T extends keyof typeof communicationTemplateKeys,
>(queryKey: ReturnType<(typeof communicationTemplateKeys)[T]>) {
  const [, marketCountry] = queryKey;
  return { marketCountry };
}
